import { NSARouterMakerResult, NSABoxSecret } from "namirasoft-account-react";
import { HostBasicAuthCreateRow, HostBasicAuthRow } from "namirasoft-credential";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

interface HostBasicAuthEditPageProps extends NSARouterMakerResult, CredentialProps
{
    isEdit: boolean;
}

export default class HostBasicAuthEditPage extends Component<HostBasicAuthEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxString_Host = createRef<NSBoxString>();
    NSABoxSecret_Username = createRef<NSABoxSecret>();
    NSABoxSecret_Password = createRef<NSABoxSecret>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    override render()
    {
        return (
            <CredentialLayout<HostBasicAuthRow, HostBasicAuthCreateRow>
                {...this.props}
                action={{
                    description: this.props.isEdit ? "This section allows you to edit a Host Basic Auth credential by updating its name, host, username, password, or description. The username and password are kept as protected secrets, and any application set up to use the credential applies the updated values." : "This section allows you to create a Host Basic Auth credential, a username and password bound to a specific host, by entering a name, the host, a username, and a password. Namirasoft encrypts the sensitive data for secure access, and any Namirasoft application you set up to use it can then sign in to that host.",
                }}
                pages={{
                    entity: CredentialEntities.host_basic_auth(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): HostBasicAuthCreateRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let host = this.NSBoxString_Host.current?.getValue() ?? "";
                                        let username = this.NSABoxSecret_Username.current?.getValue() ?? "";
                                        let password = this.NSABoxSecret_Password.current?.getValue() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        return {
                                            workspace_id: "",
                                            name,
                                            host,
                                            username,
                                            password,
                                            description,
                                            host_basic_auth_category: [],
                                            host_basic_auth_field: [],
                                            host_basic_auth_tag: [],
                                        };
                                    },
                                    setRow: (row: HostBasicAuthRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxString_Host.current?.setValue(row.host);
                                        this.NSABoxSecret_Username.current?.setValue(row.username_secret_id);
                                        this.NSABoxSecret_Password.current?.setValue(row.password_secret_id);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSRow>
                        <NSBoxString
                            ref={this.NSBoxString_Name}
                            required
                            title="Name"
                            auto_complete="new-password"
                        />
                        <NSBoxString
                            ref={this.NSBoxString_Host}
                            required
                            title="Host"
                        />
                    </NSRow>
                    <NSRow>
                        <NSABoxSecret
                            {...this.props}
                            ref={this.NSABoxSecret_Username}
                            required
                            title="User Name"
                            auto_complete="new-password"
                        />
                        <NSABoxSecret
                            {...this.props}
                            ref={this.NSABoxSecret_Password}
                            required
                            title="Password"
                            auto_complete="new-password"
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxTextArea
                            ref={this.NSBoxTextArea_Description}
                            required={false}
                            title="Description"
                            style={{ width: NSBox.width.double }}
                        />
                    </NSRow>
                </NSColumn>
            </CredentialLayout >
        );
    }
}